export default __webpack_public_path__ + "static/media/api_img.350321b7.png";